import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import Features from "../components/Features";
import Stats from "../components/Stats";
import Footer from "../components/Footer";
import Rentals from "../components/Rentals";

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
       <Rentals />
      <Services />
      <About />
      <Features />
      <Stats />
      <Footer />
    </>
  );
};

export default Home;
